"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeStateUpdate = exports.addStateUpdateField = void 0;
var bignumber_1 = require("@waves/bignumber");
var ts_types_1 = require("@waves/ts-types");
function addStateUpdateField(transaction) {
    if (transaction.type === ts_types_1.TRANSACTION_TYPE.INVOKE_SCRIPT && transaction.stateChanges.invokes && transaction.stateChanges.invokes.length) {
        var payments_1 = transaction.payment ? transaction.payment.map(function (p) { return ({
            assetId: p.assetId,
            amount: p.amount
        }); }) : [];
        return Object.defineProperty(transaction, 'stateUpdate', { get: function () { return makeStateUpdate(transaction.stateChanges, payments_1, transaction.dApp, transaction.sender); } });
    }
    else
        return transaction;
}
exports.addStateUpdateField = addStateUpdateField;
function makeStateUpdate(stateChanges, payment, dApp, sender) {
    var payments = payment.map(function (payment) { return ({ payment: payment, dApp: dApp, sender: sender }); });
    var addField = function (array, fieldName) { return array.map(function (item) {
        var _a;
        return (__assign(__assign({}, item), (_a = {}, _a[fieldName] = dApp, _a)));
    }); };
    var transfers = addField(stateChanges.transfers, 'sender');
    var leases = addField(stateChanges.leases, 'sender');
    var issues = addField(stateChanges.issues, 'address');
    var data = addField(stateChanges.data, 'address');
    var reissues = addField(stateChanges.reissues, 'address');
    var burns = addField(stateChanges.burns, 'address');
    var sponsorFees = addField(stateChanges.sponsorFees, 'address');
    var leaseCancels = addField(stateChanges.leaseCancels, 'address');
    var stateUpdate = {
        payments: payments,
        data: data,
        transfers: transfers,
        reissues: reissues,
        issues: issues,
        burns: burns,
        sponsorFees: sponsorFees,
        leases: leases,
        leaseCancels: leaseCancels,
    };
    var recursiveFunction = function (stateChanges, sender) {
        if (stateChanges.invokes.length) {
            stateChanges.invokes.forEach(function (x) {
                //payments
                if (x.payment)
                    x.payment.forEach(function (y) {
                        var index = payments.findIndex(function (z) { return (z.payment.assetId === y.assetId) && (z.dApp === x.dApp) && (sender === x.dApp); });
                        index !== -1
                            ? payments[index].payment.amount = (new bignumber_1.BigNumber(payments[index].payment.amount)).add(y.amount).toNumber()
                            : payments.push({
                                payment: y,
                                sender: sender,
                                dApp: x.dApp
                            });
                    });
                //data
                x.stateChanges.data.forEach(function (y) {
                    var index = stateUpdate.data.findIndex(function (z) { return z.key === y.key && z.address === x.dApp; });
                    index !== -1 ? stateUpdate.data[index] = __assign(__assign({}, y), { address: x.dApp }) : stateUpdate.data.push(__assign(__assign({}, y), { address: x.dApp }));
                });
                //burns
                x.stateChanges.burns.forEach(function (y) {
                    var index = stateUpdate.burns.findIndex(function (z) { return z.assetId === y.assetId; });
                    index !== -1 ? stateUpdate.burns[index].quantity += y.quantity : stateUpdate.burns.push(__assign(__assign({}, y), { address: x.dApp }));
                });
                //issues
                x.stateChanges.issues.forEach(function (y) { return stateUpdate.issues.push(__assign(__assign({}, y), { address: x.dApp })); });
                //reissues
                x.stateChanges.reissues.forEach(function (y) {
                    var index = stateUpdate.reissues.findIndex(function (z) { return z.assetId === y.assetId; });
                    index !== -1 ? stateUpdate.reissues[index].quantity += y.quantity : stateUpdate.reissues.push(__assign(__assign({}, y), { address: x.dApp }));
                });
                //transfers
                x.stateChanges.transfers.forEach(function (y) {
                    var index = stateUpdate.transfers.findIndex(function (z) { return (z.asset === y.asset) && (z.address === y.address) && (x.dApp === z.sender); });
                    index !== -1
                        ? stateUpdate.transfers[index].amount = (new bignumber_1.BigNumber(stateUpdate.transfers[index].amount)).add(y.amount).toNumber()
                        : stateUpdate.transfers.push(__assign(__assign({}, y), { sender: x.dApp }));
                });
                //sponsorFees
                x.stateChanges.sponsorFees.forEach(function (y) {
                    var index = stateUpdate.sponsorFees.findIndex(function (z) { return (z.assetId === y.assetId) && (z.address === x.dApp); });
                    index !== -1
                        ? stateUpdate.sponsorFees[index] = __assign(__assign({}, y), { address: x.dApp })
                        : stateUpdate.sponsorFees.push(__assign(__assign({}, y), { address: x.dApp }));
                });
                //lease and leaseCancels
                x.stateChanges.leases.forEach(function (y) { return stateUpdate.leases.push(__assign(__assign({}, y), { sender: x.dApp })); });
                x.stateChanges.leaseCancels.forEach(function (y) { return stateUpdate.leaseCancels.push(__assign(__assign({}, y), { address: x.dApp })); });
                recursiveFunction(x.stateChanges, x.dApp);
            });
        }
    };
    recursiveFunction(stateChanges, sender);
    return stateUpdate;
}
exports.makeStateUpdate = makeStateUpdate;
//# sourceMappingURL=transactions.js.map